
const Error = () => {
    return ('404')
}

export default Error